// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/vue/css/" + chunkId + "." + {"302":"1a0ec6b8","881":"17739cf5","974":"978c6d94"}[chunkId] + ".css";
};